import { useApiQuery } from './useApiQuery';
import { creditsApi } from '../services/creditsApi';
import type { CreditStatus } from '../services/creditsApi';

const FIVE_MINUTES = 5 * 60 * 1000;

export function useCreditStatus() {
  const { data, isLoading, error } = useApiQuery<CreditStatus>(
    ['credits', 'status'],
    () => creditsApi.getStatus(),
    {
      refetchInterval: FIVE_MINUTES,
      staleTime: FIVE_MINUTES,
    },
  );

  return {
    creditStatus: data,
    isLoading,
    error,
  };
}
